/**
 * Saved locale conditions compare `parameters.marketplace_locale` to a language code.
 * That store field stays null and is not the visitor language. Copy `locale` onto it
 * so already published expressions follow the language switch.
 */
export function withVisitorLocaleForVisibility<T extends Record<string, any>>(context: T): T {
  const parameters =
    context.parameters &&
    typeof context.parameters === 'object' &&
    !Array.isArray(context.parameters)
      ? context.parameters
      : {};

  return {
    ...context,
    parameters: {
      ...parameters,
      marketplace_locale: context.locale,
    },
  };
}
